import { useCallback } from 'react';
import { Paper, Table, TableCell, TableContainer, TableRow } from '@mui/material';
import { muiTheme } from '@styles/muiTheme';
import { DealSheetSummaryDiv } from '@styles/DealSheet/DealSheetStyles';
import { SectionTitle } from '@shared/components/SectionTitle';
import { TextInput } from '@shared/inputs/TextInput';
import { SelectDate, SelectDateEventType } from '@shared/components/SelectDate';
import { IDealSheetData, IDealSheetTableData } from '../interfaces';

export const DealSheetTable = ({ data, title, setFundedDate }: IDealSheetData) => {

  const handleDateChange = useCallback((event: SelectDateEventType) => {
    setFundedDate?.(event.target.value);
  }, []);

  const getComponent = useCallback((item: IDealSheetTableData) => {
    return (
      <>
        {
          item?.type === 'date' ? (
            <SelectDate
              disabled={!item?.editable}
              value={String(item?.value)}
              onChange={handleDateChange}
            />
          ) : (
            <TextInput
              disabled={!item?.editable}
              type="text"
              value={item?.value}
            />
          )
        }
      </>
    );
  }, [handleDateChange]);

  return (
    <DealSheetSummaryDiv>
      <SectionTitle
        title={title}
        variant="h2"
      />
      <TableContainer component={Paper}>
        <Table
          size="small"
          aria-label="a dense table"
          sx={{ border: 1, borderColor: muiTheme.palette.grey[400], borderRadius:'5px' }}
        >
          {data?.map((item) => (
            <TableRow key={item?.id}>
              <TableCell width={'55%'}>
                <strong>{item?.title}</strong>
              </TableCell>
              <TableCell width={'45%'}>
                {getComponent(item)}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </DealSheetSummaryDiv>
  );
};
